export function toUnixSeconds(dateString?: string | null): number | null {
  if (!dateString) return null;
  const normalized = dateString.length <= 10 ? `${dateString}T00:00:00Z` : dateString;
  const parsed = Date.parse(normalized);
  if (Number.isNaN(parsed)) return null;
  return Math.floor(parsed / 1000);
}

export function toIsoDate(unix?: number | null): string | undefined {
  if (!unix) return undefined;
  return new Date(unix * 1000).toISOString().split('T')[0];
}

export function toIsoDateTime(unix?: number | null): string | undefined {
  if (!unix) return undefined;
  return new Date(unix * 1000).toISOString();
}
